import TextField from '@material-ui/core/TextField';
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';

export function renderInput(inputProps) {
    const {
      helperText,
      inputValue,
      handleChange, 
      InputProps,
      classes,
      ref,
      ...other
    } = inputProps;
  
    return (
      <TextField 
      helperText={helperText}
        InputProps={{
          inputRef: ref,
          classes: {
            root: classes.inputRoot,
          },
          ...InputProps,
        }}
        {...other}
      />
    );
  }

  export function renderSuggestion({
    suggestion,
    index,
    itemProps,
    highlightedIndex,
    selectedItem
  }) {
    const isHighlighted = highlightedIndex === index;
    // const isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;

    const sel =
    selectedItem && typeof selectedItem === 'object'
      ? (selectedItem.userId || selectedItem.id || selectedItem.value)
      : selectedItem;

  const isSelected =
    sel === suggestion.userId || sel === suggestion.label;
  
    return (
      <MenuItem
        {...itemProps}
        key={suggestion.userId}
        selected={isHighlighted}
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400,
        }}
      >
        {suggestion.email}
      </MenuItem>
    );
  }


  //importante llena
  export function getSuggestions(inputValue,array) {
    let count = 0;
  
    return array.filter(suggestion => { 
      //AHDA 09/05/2019
      //Validation when empty
      const sugg = suggestion.email ?  suggestion.email.toLowerCase().indexOf(inputValue.toLowerCase()) : ""
      const keep = (!inputValue || sugg !== -1) && count < 5;
  
      if (keep) {
        count += 1;
      }
  
      return keep;
    });
  }

  export function getSuggestionsAll(inputValue, array) {
  let count = 0;
  const maxResults = inputValue ? 5 : array.length; // Si no hay input, muestra todas

  return array.filter(suggestion => { 
    const sugg = suggestion.email ? suggestion.email.toLowerCase().indexOf(inputValue.toLowerCase()) : ""
    const keep = (!inputValue || sugg !== -1) && count < maxResults;

    if (keep) {
      count += 1;
    }

    return keep;
  });
}

